module.exports = __webpack_public_path__ + "img/xt_01.17bb7644.png";